// extracted by mini-css-extract-plugin
export default {"topBg":"styles_topBg__3FEYS","timerPreText":"styles_timerPreText__b-SFC"};